<input #field
       type="text"
       class="form-control"
       [ngModel]="innerValue"
       (ngModelChange)="writeValue($event)"
       maxlength="14"
       (blur)="onTouched()"
       [placeholder]="placeholder || ''">
